var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{on:{"click":_vm.openLevelsmenu}},[_vm._v("Open LevelsMenu from Ref")]),_c('AppLevelsMenu',{ref:"levelsMenu",attrs:{"level-menu-items":_vm.levelMenuItems},on:{"width-updated":_vm.widthUpdated}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }